import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import { EProductTypeQueryUrl } from "@/3514/config"
import type { IProductTypeDto } from "@/3514/types"

async function productTypeFetcher(): Promise<IProductTypeDto> {
    const { data }: AxiosResponse<IProductTypeDto> = await axiosClient.get(EProductTypeQueryUrl())

    return data
}

export { productTypeFetcher }
